type Props = {
	size?: 'small' | 'medium' | 'large' | 'auto';
	color?: 'primary' | 'secondary' | 'light' | string;
};

const Loader = ({size = 'medium', color = 'primary'}: Props) => {
	const getSize = () => {
		switch (size) {
			case 'small':
				return 20;
			case 'large':
				return 60;
			case 'auto':
				return 40; // будет переопределен в стиле
			default:
				return 40;
		}
	};

	const getColor = () => {
		switch (color) {
			case 'primary':
				return '#7a934f';
			case 'secondary':
				return '#133215';
			case 'light':
				return '#b5c775';
			default:
				return color;
		}
	};

	const sizeValue = getSize();
	const colorValue = getColor();
	const borderWidth = Math.max(2, sizeValue / 15);

	const spinnerStyle: React.CSSProperties = {
		width: size === 'auto' ? '100%' : `${sizeValue}px`,
		height: size === 'auto' ? '100%' : `${sizeValue}px`,
		maxWidth: size === 'auto' ? '60px' : 'none',
		maxHeight: size === 'auto' ? '60px' : 'none',
		border: `${borderWidth}px solid rgba(122, 147, 79, 0.1)`,
		borderTop: `${borderWidth}px solid ${colorValue}`,
		borderRadius: '50%',
		animation: 'spin 1s linear infinite',
		display: 'block',
	};

	return (
		<>
			<style>{`
				@keyframes spin {
					0% { transform: rotate(0deg); }
					100% { transform: rotate(360deg); }
				}
			`}</style>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: size === 'auto' ? '100%' : 'auto',
					height: size === 'auto' ? '100%' : 'auto',
				}}
			>
				<div style={spinnerStyle}></div>
			</div>
		</>
	);
};

export default Loader;
